import { render, staticRenderFns } from "./PDFViewer.vue?vue&type=template&id=13a2561b&scoped=true&"
import script from "./PDFViewer.vue?vue&type=script&lang=ts&"
export * from "./PDFViewer.vue?vue&type=script&lang=ts&"
import style0 from "./PDFViewer.vue?vue&type=style&index=0&id=13a2561b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a2561b",
  null
  
)

export default component.exports